export default __webpack_public_path__ + "static/GraphikBold-e78d3d4f87bc060c0a1a6997adba4c77.otf";